<template lang="pug">
#monirotamento-socioambiental
    section.monirotamento-socioambiental__resultado
        .monirotamento-socioambiental__resultado__body
            GruposAlerta.mb-4(
                v-if='gruposAlerta',
                :gruposAlerta='gruposAlerta',
                :altura='90',
                :isHorizontal='true'
            )

            section
                h3.mb-3
                    i.flow.flow-shape.margin-icone.mr-2
                    b {{ $t('mensagens.territorio.titulo') }}: {{ territorio.dadosTerritorio.nome }}

                DiagnosticoSocioambiental.mb-3.mt-3(
                    style='padding: 0; display: grid',
                    :dadosConsulta='territorio',
                    :habilitar-opacidade='true',
                    :habilitar-sinal-aviso='true',
                    @index-aberto='atualizarRestricaoMapa'
                )

            section(v-for='representante in representantes')
                h3.mb-3
                    i.flow.flow-user-second.margin-icone.mr-2
                    b {{ $t('mensagens.comuns.pessoa') }}: {{ representante.nomeRepresentante }}

                DiagnosticoSocioambiental.mb-3(
                    style='padding: 0; display: grid',
                    :dadosConsulta='representante',
                    :habilitar-sinal-aviso='true',
                    :habilitar-opacidade='true'
                )

    section.monirotamento-socioambiental__mapa.mapa.w-100.h-100
        mapa(
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :height='"100%"',
            :idMapa='"mapaMonitoramentoSocioambiental"',
            ref='mapa',
            :menuMaior='true'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import TerritorioService from '@/services/TerritorioService';
import GruposAlerta from '@/components/GruposAlerta.vue';

import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'MonitoramentoSocioambiental',

    components: {
        Mapa,
        DiagnosticoSocioambiental,
        GruposAlerta
    },

    props: {
        idTerritorio: {
            type: Number,
            required: true
        },
        gruposAlerta: {
            required: false,
            type: Array,
            default: null
        }
    },

    data() {
        return {
            territorio: {
                dadosTerritorio: {},
                diagnosticos: []
            },
            representantes: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    ferramentasControl: false
                }
            },
            pesquisaValida: true,
            areasRestricao: [],
            indexUltimaRestricaoAberta: null
        };
    },

    created() {
        TerritorioService.findById(this.idTerritorio)
            .then(({ data }) => {
                this.territorio.dadosTerritorio = data;
                setTimeout(this.configureLayersMapa(), 500);
            })
            .catch(() => {
                this.$notify.error({
                    message: 'Ocorreu um erro ao buscar os dados do territorio'
                });
            });

        TerritorioService.diagnosticoSocioambiental(this.idTerritorio, false)
            .then(({ data }) => {
                this.representantes = data.diagnosticoPorRepresentante;
                this.territorio.diagnosticos = data.responseDiagnosticos.map(
                    r => ({
                        camada: { ...r.camada, opacidade: 100 },
                        resultados: r.resultados.map(r => r.properties),
                        nivelAlerta: r.nivelAlerta,
                        status: r.status,
                        geometria: r.resultados.map(
                            r => r.geometria || r.geometry
                        )
                    })
                );
                Object.keys(this.territorio.diagnosticos).forEach(item => {
                    if (
                        this.territorio.diagnosticos[item].camada.nome ===
                        'Áreas embargadas'
                    ) {
                        this.territorio.diagnosticos[item].camada.nome =
                            'Áreas embargadas (IBAMA)';
                    } else if (
                        this.territorio.diagnosticos[item].camada.nome ===
                        'Monitoramento Desmatamento'
                    ) {
                        this.territorio.diagnosticos[item].camada.nome =
                            'Desmatamento Lyra';
                    }
                });
            })
            .catch(() => {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os dados do diagnostico socioambiental'
                });
            });
    },

    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'Área Monitorada',
                geoJson: this.territorio.dadosTerritorio.geometria
            };

            this.layersMaps.push(layerAreaMonitorada);
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, restricao) {
            this.configureLayersMapa();

            const opacidade =
                this.areasRestricao.camada.opacidade >= 0.0
                    ? this.areasRestricao.camada.opacidade / 200
                    : 0.5;

            this.areasRestricao.areas.forEach((area, index) => {
                let layerAreaDiagnostico;
                if (
                    restricao &&
                    restricao.index === index &&
                    restricao.overOrLeave === 'over'
                ) {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'orange',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: area
                    };
                } else {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: area
                    };
                }

                this.layersMaps.push(layerAreaDiagnostico);
            });
        },

        atualizarRestricaoMapa(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = [];

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAberta}-monitoramento`;
            this.layersMaps = this.layersMaps.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );
            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAberta = indexCollapseRow;

                this.areasRestricao = {
                    areas: this.territorio.diagnosticos[indexCollapseRow]
                        .geometria,
                    camada: this.territorio.diagnosticos[indexCollapseRow]
                        .camada
                };

                const tagRestricaoAdd = `${indexCollapseRow}-monitoramento`;
                this.mostrarAreasDiagnosticoNoMapa(tagRestricaoAdd, restricao);
            }
        }
    }
};
</script>

<style lang="scss">
#monirotamento-socioambiental {
    height: 100%;
    width: 100%;
    display: flex;

    .monirotamento-socioambiental__resultado {
        @include scroll-bar();
        background-color: var(--white);
        border-radius: 5px 0 0 5px;
        padding: 20px;
        overflow-y: auto;
        width: 45%;

        .monirotamento-socioambiental__resultado__header {
            height: auto;
            margin-bottom: 15px;
            display: flex;
        }

        .monirotamento-socioambiental__resultado__body {
            height: 100%;
            overflow-y: auto;
        }
    }

    .monirotamento-socioambiental__mapa {
        width: 55%;
    }

    .grupo-alerta-horizontal {
        width: 100%;
    }
}
</style>
